module.exports = __webpack_public_path__ + "images/external_images/img/204x361/img8.jpg";